export const viewMoreIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ marginBottom: '3px' }}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 4C10.5523 4 11 4.44772 11 5V9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H11V15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15V11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H9V5C9 4.44772 9.44772 4 10 4Z"
        fill="#5F5F5F"
      />
    </svg>
  )
}

export const viewLessIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ marginBottom: '3px' }}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 9C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H5Z"
        fill="#5F5F5F"
      />
    </svg>
  )
}
